/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React, {Ref} from 'react'
import {useThemeName} from '@enisco/mcc-react-lib'

interface Props {
  height?: string
  darkIcon?: string
  lightIcon?: string
  fixedIcon?: string
  ref?: Ref<HTMLImageElement>
  onLoad?: () => void
}

const Logo: React.FC<Props> = ({height, darkIcon, lightIcon, fixedIcon, ref, onLoad}) => {
  const [themeName] = useThemeName()

  let icon = lightIcon
  if(fixedIcon) {
    icon = fixedIcon
  } else if(themeName === 'dark') {
    icon = darkIcon
  }

  return <img src={icon} height={height} alt='Logo' ref={ref} onLoad={onLoad}/>
}

export default Logo
